import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import { TeacherAvatar } from "./TeacherSelect";
import { dateFormatDisplay } from "../lib/dates";
import { URL_TYPE_OPTIONS } from "../constants";

// One lecture row. The legacy table had five edit icons that all opened the
// same update modal with the same preamble — merged here into one "Düzenle"
// action (same opener, see container). The Date column keeps its own edit icon
// because it opens the separate two-step date flow.
const LectureRow = ({
    item,
    onEditDate,
    onEditLecture,
    onDuplicateLecture,
    onAddHomework,
    onEditHomework,
    onDeleteHomework,
    onDeleteLecture,
    onUrlTypeChange,
}) => {
    return (
        <tr>
            <td>
                <div className="olp-lecture-cell">
                    <img className="olp-row-thumb" src={item.ThumbnailUrl} alt="" />
                    <div className="olp-lecture-cell-titles">
                        {item.Title && <span className="olp-lecture-title">{item.Title}</span>}
                        {item.TopicName && <span className="olp-lecture-subtitle">{item.TopicName}</span>}
                        {item.SubTopicName && <span className="olp-lecture-subtitle">{item.SubTopicName}</span>}
                    </div>
                </div>
            </td>
            <td>
                <div className="olp-date-cell">
                    <button
                        className="olp-btn olp-btn--ghost olp-btn--sm"
                        title="Tarihi değiştir"
                        onClick={() => onEditDate(item)}
                    >
                        <EditIcon style={{ fontSize: 16 }} />
                    </button>
                    {dateFormatDisplay(item.Date)}
                </div>
            </td>
            <td>
                <div className="olp-teacher-cell">
                    <TeacherAvatar
                        teacher={{
                            ImageUrl: item.TeacherInfos.ImageUrl,
                            TeacherName: item.TeacherInfos.TeacherName,
                        }}
                        large
                    />
                    {item.TeacherInfos.TeacherName}
                </div>
            </td>
            <td>
                <div className="olp-hw-list">
                    <button className="olp-btn olp-btn--sm" onClick={() => onAddHomework(item)}>
                        Ödev ekle
                    </button>
                    {item.Homeworks.map((homeWork) => (
                        <div className="olp-hw-item" key={homeWork.Id}>
                            <button
                                className="olp-btn olp-btn--ghost olp-btn--sm"
                                title="Ödevi düzenle"
                                onClick={() => onEditHomework(item, homeWork)}
                            >
                                <EditIcon style={{ fontSize: 15 }} />
                            </button>
                            <span className="olp-hw-item-text">
                                {homeWork.Title}/{homeWork.Description}
                            </span>
                            <button
                                className="olp-btn olp-btn--danger olp-btn--sm"
                                onClick={() => onDeleteHomework(homeWork)}
                            >
                                Ödevi sil
                            </button>
                        </div>
                    ))}
                </div>
            </td>
            <td>
                {item.LectureNoteUrl && (
                    <div>
                        <a className="olp-link" href={item.LectureNoteUrl} target="_blank" rel="noopener noreferrer">
                            {item.LectureNoteUrl}
                        </a>
                    </div>
                )}
                {item.StreamUrl && (
                    <div>
                        <a className="olp-link" href={item.StreamUrl} target="_blank" rel="noopener noreferrer">
                            {item.StreamUrl}
                        </a>
                    </div>
                )}
            </td>
            <td>
                {/* Instant per-row url-type change — intentionally not confirm-gated */}
                <select
                    className="olp-select olp-select--inline"
                    value={item.OfflineUrlType}
                    onChange={(event) => onUrlTypeChange(event, item)}
                >
                    {URL_TYPE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </td>
            <td>
                <div className="olp-meta-list">
                    <span>
                        Id: <b>{item.Id}</b>
                    </span>
                    <span>
                        CourseId: <b>{item.CourseId}</b>
                    </span>
                    <span>
                        ExamCategoryId: <b>{item.ExamCategoryId}</b>
                    </span>
                    <span>
                        ExamType: <b>{item.ExamType}</b>
                    </span>
                    <span>
                        SubCourseTopicId: <b>{item.SegmentTopicId}</b>
                    </span>
                    <span>
                        RowStatus: <b>{String(item.RowStatus)}</b>
                    </span>
                </div>
            </td>
            <td>
                <div className="olp-cell-actions">
                    <button className="olp-btn olp-btn--sm" onClick={() => onEditLecture(item)}>
                        Düzenle
                    </button>
                    <button
                        className="olp-btn olp-btn--sm"
                        title="Bu dersi kopyalayarak yeni tarihli bir ders oluştur"
                        onClick={() => onDuplicateLecture(item)}
                    >
                        Çoğalt
                    </button>
                    <button className="olp-btn olp-btn--danger olp-btn--sm" onClick={() => onDeleteLecture(item)}>
                        Dersi sil
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default LectureRow;
